export default {
  priority: 95,
  name: app.translate('routes.home.attendance.leave.amount leave'),
  path: 'AmountLeave',
  permissions: ['TimeAttendanceMenu/RemainingLeaveMenu/DefineRemainingLeaveMenu'],
  component: load(() => import(/* webpackChunkName: "amount" */ './AmountLeave')),
  icon: 'folder-plus',
  drawer: true,
};